<script setup lang="ts">
import { getCategoryRoute, getTranslatedProperty } from "@shopware/helpers"
import type { Schemas } from "#shopware"

const props = defineProps<{
    navigation: Schemas["Category"][]
    lgAndLarger: boolean
}>()

const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)

const getTabindex = (elementId: string, accordionOpenItemId: string | null, isDesktopMode: boolean) => {
    // If on desktop, all links should always be tabbable
    if (isDesktopMode) return 0

    // If on mobile, only tabbable if accordion is open
    return accordionOpenItemId === elementId ? 0 : -1
}
</script>
<template>
    <ComponentAccordion
        :items="props.navigation.map(nav => ({
            id: nav.id,
            headline: getTranslatedProperty(nav, 'name')
        }))"
        headline-tag="h3"
        :no-accordion-on-desktop="lgAndLarger"
        :has-border="false"
        type="single"
        class="grid flex-1 grid-cols-1 lg:grid-cols-4 w-full"
    >
        <template
            v-for="navigationElement in props.navigation"
            :key="navigationElement.id"
            #[navigationElement.id]="{ isOpen }"
        >
            <ul v-if="navigationElement.childCount > 0" class="list-none py-4 lg:py-0">
                <li
                    v-for="navigationChild in navigationElement.children"
                    :key="navigationChild.id"
                    class="my-1 lg:my-0"
                >
                    <FoundationLink
                        :target="navigationElement.externalLink || navigationElement.linkNewTab
                            ? '_blank'
                            : undefined
                        "
                        :to="formatLink(getCategoryRoute(navigationChild))"
                        class="footer-link text-neutral text-base lg:text-sm leading-6"
                        :tabindex="getTabindex(navigationElement.id, isOpen ? navigationElement.id : null, lgAndLarger)"
                    >
                        {{ getTranslatedProperty(navigationChild, "name") }}
                    </FoundationLink>
                </li>
            </ul>
        </template>
    </ComponentAccordion>
</template>
